import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltipClick, tooltip, priceFenToYuanCell } from '@/components/TableCell';
import { encryptedTelNumber, encryptedName } from '@/assets/js/utils';
import { isOC } from '@/assets/js/authType';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(isOC() ? encryptedTelNumber(text) : text, () => { this.props.tableAction('detail', record); })
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推荐来源',
            dataIndex: 'referrerUserRole',
            key: 'referrerUserRole',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所属运营中心',
            dataIndex: 'operationName',
            key: 'operationName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '经纪人状态',
            dataIndex: 'statusStr',
            key: 'statusStr',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收益',
            dataIndex: 'income',
            key: 'income',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '注册时间',
            dataIndex: 'brokerOpenTime',
            key: 'brokerOpenTime',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'userId',
            key: 'userId',
            align: 'center',
            width: '30%',
            render: (id, item) => this._TableAction(item)
        },
    ];

    _ocColumns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(isOC() ? encryptedTelNumber(text) : text, () => { this.props.tableAction('detail', record); })
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => tooltip(isOC() ? encryptedName(text) : text)
        },
        {
            title: '推荐来源',
            dataIndex: 'referrerUserRole',
            key: 'referrerUserRole',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所属运营中心',
            dataIndex: 'operationName',
            key: 'operationName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '经纪人状态',
            dataIndex: 'statusStr',
            key: 'statusStr',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'brokerOpenTime',
            key: 'brokerOpenTime',
            width: '25%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        // // 当为禁用或拉黑时，显示为'启用'
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', record)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
            </div>
        );
    };

    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowSelection={rowSelection}
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(r) => r.userId}
                    columns={isOC() ? this._ocColumns() : this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

